module.exports = __webpack_public_path__ + "img/槟榔.c81809af.jpg";